/**
 * Copyright (C) Sitevision 2002-2023, all rights reserved
 */
import { hasPortlet } from '../util/findPortlets';

if (hasPortlet('sv-proxy-portlet')) {
  import(/* webpackChunkName: "proxy-portlet" */ './plugins-slim');
}
